import waves from '@/directive/waves'; // 水波纹指令

import { parseTime, getFileByUrl } from '@/utils/index';

import elDragDialog from '@/directive/el-dragDialog';
import SelectType from '@/components/SelectType';
import permissionBtn from '@/components/PermissionBtn';
import Pagination from '@/components/Pagination';
import myTransfer from '@/components/Transfer';
import Sticky from '@/components/Sticky';
import filterForm from '@/components/FilterForm';
import autoNew from '@/components/AutoNew';
import Layout from '@/views/layout/Layout';
import addInstance from '@/components/BizInstance/add';
import editInstance from '@/components/BizInstance/edit';
import { mapGetters } from 'vuex';

export default {
  components: {
    myTransfer,
    permissionBtn,
    Pagination,
    SelectType,
    Sticky,
    filterForm,
    autoNew,
    addInstance,
    editInstance
  },
  directives: {
    waves,
    elDragDialog
  },
  data() {
    return {
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      statusOptions: [
        { key: 1, display_name: '停用' },
        { key: 0, display_name: '正常' }
      ],
      dialogFormVisible: false,
      dialogEditVisible: false,
      dialogQueryVisible: false,
      dialogSetVisible: false, // field设置dialog
      dialogStatus: '',
      headerList: [],
      rules: {
        appId: [{ required: true, message: '必须选择一个应用', trigger: 'change' }],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      },
      queryData: [],
      filterObj: [],
      downloadLoading: false,
      drawer: false,
      drawerobjtype: '',
      drawertemp: {},
      temp: {
        flowInstanceId: '',
        isFinish: '',
        activityType: ''
      },
      initQueryData: [], // 默认查询条件
      menukeyArray: []
    };
  },
  watch: {
    currentAccName(newValue) {
      this.initData.accName = newValue;
    },
    currentAccId(newValue) {
      this.initData.AccountId = newValue;
      this.listQuery.AccountId = newValue;
    }
  },
  computed: {
    ...mapGetters(['currentAccId', 'currentAccName', 'accList']),
    frmData: function() {
      return this.dialogStatus === 'create' ? 'frmData' : 'frmEditData';
    },
    dataForm: function() {
      return this.dialogStatus === 'create' ? 'dataForm' : 'editForm';
    },
    formref: function() {
      if (this.dialogFormVisible) {
        return this.$refs['dataForm'].$refs['frmData'];
      } else {
        return this.$refs['editForm'].$refs['frmEditData'];
      }
    }
  },
  filters: {
    filterInt(val) {
      switch (val) {
        case null:
          return '';
        case 1:
          return '状态1';
        case 2:
          return '状态2';
        default:
          return '默认状态';
      }
    },
    statusFilter(disable) {
      const statusMap = {
        false: 'color-success',
        true: 'color-danger'
      };
      return statusMap[disable];
    },
    dateFormat(datetitme) { // 时间格式化
      return datetitme ? parseTime(new Date(datetitme), '{y}-{m}-{d}') : '';
    }, intToTureFalse(data) {
      return data === 0 ? '否' : '是';
    },
    dateFormats(datetitme) { // 时间格式化
      return datetitme ? parseTime(new Date(datetitme)) : '';
    }
  },

  created() {
    this.listQueryInit();
    var addRouter = [{
      path: '/' + this.crmType + 'flow',
      component: Layout,
      redirect: 'noredirect',
      name: this.crmType + 'flow',
      meta: {
        title: '流程中心',
        icon: 'guide'
      },
      children: [
        {
          path: 'detail/:id',
          component: () =>
            import('@/views/flowinstances/detail'),
          name: this.crmType + 'floweDetail',
          hidden: true,
          meta: {
            notauth: true,
            title: '流程详情',
            noCache: true,
            icon: 'list'
          }
        }
      ]
    }];
    this.$router.addRoutes(addRouter);
    this.checkFunction(this.createdafter);
  },
  methods: {
    getFormObj() {
      return this.$refs[this.dataForm].$refs[this.frmData];
    },
    getFormPostObj() {
      return this.$refs[this.dataForm].$refs['postObj'];
    },
    getAccountId() {
      return this.currentAccId;
    },
    getFileByUrl(res) {
      getFileByUrl(res);
    },
    clickLoadDile() {
      this.getApi().getloadfile(this.listQuery).then(res => {
        getFileByUrl(res);
      });
    },
    openFlowinstances(row) { // 跳转详细页面
      this.$router.push('/' + this.crmType + 'flow/detail/' + row.flowInstanceId);
    },
    rowClick(row) {
      this.$refs.mainTable.clearSelection();
      this.$refs.mainTable.toggleRowSelection(row);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBtnClicked: function(domId) {
      switch (domId) {
        case 'btnAdd':
          this.handleCreate();
          break;
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error'
            });
            return;
          }
          this.handleUpdate(this.multipleSelection[0]);
          break;
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error'
            });
            return;
          }
          this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleDelete(this.multipleSelection);
          }).catch(() => {
          });
          break;
        case 'btnSearch':
          this.dialogQueryVisible = true;
          break;
        case 'btnSet':
          this.dialogSetVisible = true;
          break;
        case 'btnClear':
          // this.$refs['queryForm'].queryClear()
          // this.listQueryInit()
          this.handleClear();
          break;
        case 'btnAccessUser':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行共享',
              type: 'error'
            });
            return;
          }
          if (this.$refs.accessUser !== undefined) {
            this.$refs.accessUser.handleAccessUser(this.multipleSelection[0]);
          }
          break;
        case 'btnLoadFile':
          this.clickLoadDile();
          break;
        default:
          this.checkFunction(this.btnClickOther, domId);
          // if()//添加其他页面逻辑
          break;
      }
    },
    handleCreate() {
      this.dialogStatus = 'create';
      this.checkFunction(this.beforCreate);
      this.dialogFormVisible = true;
      this.checkFunction(this.lastCreate);
    },
    handleUpdate(row) { // 弹出编辑框
      this.getApi().get(row.id).then(response => {
        this.temp = response.result == null ? {} : response.result;
        this.checkFunction(this.beforUpdate);
        this.temp.flowInstanceId = this.temp.flowInstanceId == null ? '' : this.temp.flowInstanceId;
        this.temp.isFinish = row.isFinish ? row.isFinish : 0;
        this.temp.activityType = row.activityType ? row.activityType : 0;
        this.dialogStatus = 'update';
        this.dialogEditVisible = true;
        this.checkFunction(this.lastUpdate);
      });
    },
    RefreshRowData(row) {
      for (const v of this.list) {
        if (v.id === row.id) {
          const index = this.list.indexOf(v);
          this.list.splice(index, 1, row);
          break;
        }
      }
    },
    getList() {
      this.listLoading = true;
      this.getApi().getList(this.listQuery).then(response => {
        this.list = response.data;
        const newruleitem = {};
        response.columnHeaders.forEach((item) => {
          item.key = item.key.substring(0, 1).toLowerCase() + item.key.substring(1);
          // item.relation = item.relation && item.relation !== '' ? item.relation.split('/') : []// 查询条件下拉框
          if (item.formatter) {
            newruleitem[item.key] = JSON.parse(item.formatter);
          }
        });
        this.headerList = response.columnHeaders.filter(u => u.browsable);
        this.rules = Object.assign(this.rules, newruleitem);
        // this.queryData = response.columnHeaders.filter(u => u.isQuery)// 是否启用查询
        this.total = response.count;
        this.listLoading = false;
      });
    },
    handleDelete(rows) { // 多行删除
      this.getApi().del(rows.map(u => u.id)).then(() => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        });
        // rows.forEach(row => {
        //   const index = this.list.indexOf(row)
        //   this.list.splice(index, 1)
        // })
        this.getList();
      });
    },
    handleClear() { // 清空查询
      if (this.$refs.queryForm === undefined) {
        return;
      }// 判断是否打开过查询界面，若没有则直接返回，说明没有添加过查询条件
      this.$refs.queryForm.queryClear();// 清空查询条件
      this.listQueryInit();// 查询参数初始化
    },
    listQueryInit() {
      this.initQueryData = [];// 初始化查询参数
      if (typeof (this.beforListQueryInit) === 'function') {
        this.initQueryData = this.beforListQueryInit();
      }
      this.handleFilter();
    },
    handleFilter(data) {
      this.checkFunction(this.InitFilter);
      if (data && data.length > 0) {
        this.filterObj = this.AssTableData(data, this.filterObj);
      } else {
        this.filterObj = [];
      }
      this.filterObj = this.AssTableData(this.initQueryData, this.filterObj);// 添加默认查询条件

      this.listQuery.wheres = JSON.stringify(this.filterObj);
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getList();
    },
    handleSortChange(column) {
      this.listQuery.sort = column.prop;
      this.listQuery.order = column.order;
      this.listQuery.page = 1;
      this.getList();
    },
    AssTableData(val, tabledata) { // 添加或修改查询数据
      tabledata = tabledata.filter(u => u.value !== '');
      val.forEach(item => {
        const index = tabledata.findIndex(m => {
          return m.field === item.field;
        });
        if (index > -1) {
          if (item.value === null) {
            tabledata.splice(index, 1);
          } else {
            tabledata[index].value = item.value;
            tabledata[index].relation = item.relation ? item.relation : '==';
          }
        } else {
          tabledata.push({
            field: item.field,
            value: item.value,
            relation: item.relation ? item.relation : '=='
          });
        }
      });
      return tabledata;
    },
    openDrawer(row, type) { // 打开抽屉
      // this.temp = Object.assign({}, this.list[rowindex]) // copy obj
      if (typeof (this.beforOpenDrawer) === 'function' && type !== 'cmsCustomerMst') {
        this.beforOpenDrawer(row, type);
      }
    },
    checkFunction(fn, val) {
      if (typeof (fn) === 'function') {
        fn(val);
      }
    },
    checkTableDetailsExist(filedObj) { // 当有子表单不能为空的情况出现时，在页面的otherSubmit方法中调用这个方法就行了，方法需要子表单绑定的字段名和错误信息对象
      const parm = this.getFormObj().GetModelData();
      let timeout = 100;
      let internalFlag = true;
      filedObj.forEach(obj => {
        if (parm[obj.filedName] === undefined || parm[obj.filedName] === null || parm[obj.filedName].length <= 0) {
          internalFlag = false;
          setTimeout(() => this.$message.error(obj.msg), timeout);
          timeout = timeout + 100;
        }
      });

      return internalFlag;
    }
  }
};
